// extracted by mini-css-extract-plugin
module.exports = {"container":"jgp-3e2wI","legend":"jgp-2Qp0t"};